/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { useEffect, useRef } from 'react';
import { useActiveSinkId } from '../../../../state/useActiveSinkId/useActiveSinkId';
import { useVideoContext } from '../../../../contexts/videoProvider/videoContext';

export namespace AudioTrack {
  export interface Props {
    track: VideoProvider.ILocalAudioTrack;
  }
}

export const AudioTrack: React.FC<AudioTrack.Props> = ({ track }) => {
  const { localTracks } = useVideoContext();
  const { activeSinkId } = useActiveSinkId(localTracks);
  const audioEl = useRef<any>();

  useEffect(() => {
    audioEl.current = track.attach();
    // Hide it for a11y so keyboard users can't tab to it
    audioEl.current.setAttribute('tabindex', '-1');
    document.body.appendChild(audioEl.current);
    return () => track.detach().forEach(el => el.remove());
  }, [track]);

  useEffect(() => {
    audioEl.current?.setSinkId?.(activeSinkId);
  }, [activeSinkId]);

  return null;
};
